import { Box, Stack } from '@mui/material';
import { SPECIALIZED_REPORT_TYPE } from 'modules/common/apiConstants';
import Report from 'modules/common/component/report';
import { REPORT_VIEW_MODE } from 'modules/common/component/report/consts';
import EncounterReportTable from 'modules/common/page/report/work/medicalExam/EncounterReportTable';
import EncounterServiceChart from 'modules/common/page/report/work/medicalExam/EncounterServiceChart';
import EncounterTimeChart from 'modules/common/page/report/work/medicalExam/EncounterTimeChart';
import { ValueType } from 'modules/common/type';
import { SPECIALIST } from 'modules/layout/constants';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'redux/reducer';

const EncounterReportTab = () => {
  const [viewMode, setViewMode] = useState<keyof typeof REPORT_VIEW_MODE>('TABLE');
  const isDentalClinic = useSelector(
    (state: AppState) => state.authen.user?.group_specialization === SPECIALIST.DENTAL,
  );
  const typeOption: ValueType<typeof SPECIALIZED_REPORT_TYPE>[] = useMemo(() => {
    return isDentalClinic
      ? [SPECIALIZED_REPORT_TYPE.DENTAL, SPECIALIZED_REPORT_TYPE.THERAPY]
      : [SPECIALIZED_REPORT_TYPE.ENCOUNTER, SPECIALIZED_REPORT_TYPE.THERAPY];
  }, [isDentalClinic]);
  return (
    <Report>
      <Stack direction="column" position="relative">
        <Stack direction="row" justifyContent="flex-end" position="absolute" top={-10} right={0}>
          <Report.SwitchLayout onChange={(viewMode) => setViewMode(viewMode)} />
        </Stack>
        <Box marginTop={1}>
          {viewMode === 'TABLE' ? (
            <EncounterReportTable typeOption={typeOption} />
          ) : (
            <Stack direction="column">
              <EncounterTimeChart typeOption={typeOption} />
              <EncounterServiceChart typeOption={typeOption} />
            </Stack>
          )}
        </Box>
      </Stack>
    </Report>
  );
};

export default EncounterReportTab;
